import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import classnames from 'classnames';
import s from './PopoverArrow.scss';
const arrowSize = parseInt(s['arrow_size']);
const getArrowPosition = (placement, position, containerSize)=>{
    const highLimit = containerSize - arrowSize * 2;
    const lowLimit = arrowSize;
    // The offset adjusts the arrow to point correctly to the reference.
    // We need this because our arrow is not centered by design.
    const offset = [
        'top',
        'left'
    ].includes(placement) ? arrowSize / 2 : -arrowSize / 2;
    return Math.max(lowLimit, Math.min(highLimit, position + offset));
};
const getArrowPositionStyles = (style, placement, contentWidth, contentHeight)=>{
    let { left, top } = style;
    if (Number.isInteger(left) && contentWidth) {
        left = getArrowPosition(placement, left, contentWidth);
    } else if (Number.isInteger(top) && contentHeight) {
        top = getArrowPosition(placement, top, contentHeight);
    }
    return _object_spread_props(_object_spread({}, style), {
        left,
        top
    });
};
/** Basic popover arrow component, does not apply any styles, only positioning.
 *  You will need to apply your own arrow svg etc. when using this
 */ const PopoverArrow = /*#__PURE__*/ React.forwardRef(({ className, wrapperClassName, style = {}, simpleArrowPosition, placement, contentWidth, contentHeight, attributes }, ref)=>{
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, attributes), {
        ref: ref,
        className: classnames(s['root'], s[placement], wrapperClassName),
        style: simpleArrowPosition ? style : getArrowPositionStyles(style, placement, contentWidth, contentHeight)
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['arrow'], className)
    }));
});
PopoverArrow.displayName = 'PopoverArrow';
export default PopoverArrow;

//# sourceMappingURL=PopoverArrow.js.map